import { Schema } from "effect";
import { BulkConversationAction } from "../shopper-ai/conversation/bulk-conversation-action";

export const BulkConversationActionProgressStatus = Schema.Literal(
  "started",
  "processing",
  "completed",
  "failed",
);
export type BulkConversationActionProgressStatus =
  typeof BulkConversationActionProgressStatus.Type;

export const BulkConversationActionProgressNotification = Schema.Struct({
  _tag: Schema.Literal("bulkConversationActionProgress"),
  workflowId: Schema.String,
  action: BulkConversationAction,
  status: BulkConversationActionProgressStatus,
  totalCount: Schema.Number,
  processedCount: Schema.Number,
  failedCount: Schema.Number,
});
export type BulkConversationActionProgressNotification =
  typeof BulkConversationActionProgressNotification.Type;

export const UserNotification = Schema.Union(
  BulkConversationActionProgressNotification,
);
export type UserNotification = typeof UserNotification.Type;
